import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b7805702&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=b7805702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7805702",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b7805702')) {
      api.createRecord('b7805702', component.options)
    } else {
      api.reload('b7805702', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b7805702&scoped=true&", function () {
      api.rerender('b7805702', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/appearance/index.vue"
export default component.exports